module.exports = __webpack_public_path__ + "img/zy@2x.fa2903a0.png";